import script from "./Automations.vue?vue&type=script&setup=true&lang=ts"
export * from "./Automations.vue?vue&type=script&setup=true&lang=ts"

import "./Automations.vue?vue&type=style&index=0&id=38ac76d8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ac76d8"]])